import { useCallback, useMemo, useState } from 'react';
import celular from '../../assets/celular.png';
import { useInduction } from '../../hooks/useInduction';

import { Container, SentMessageTo, TermSentViaText, Button, BeneficiaryNotReceivedText, ResendContainer } from './styles';
import { ModalValidTerm } from '../ModalValidTerm';
import { acceptanceTermEmailOnlyBenefitIds } from '../../util/aliasHidden';

export function ValidTermAccepted() {
    const { beneficiaryInfo, benefitId, canProceedWithoutAccept, benefitName, termDeclined, ProceedToForm, getBeneficiaryPreCad, GoToForm, reSendTerm, backToContact, closeModalDeclinedTerm } = useInduction();

    const [resendTerm, setResendTerm] = useState(false);
    const [resendTermVia, setResendTermVia] = useState<string | undefined>(beneficiaryInfo?.tipoEnvio);
    const isEmailOnlyBenefit = acceptanceTermEmailOnlyBenefitIds.includes(benefitId);
    const activeDeliveryChannel = resendTermVia || beneficiaryInfo?.tipoEnvio || 'email';
    
    const [showModalConcentimentCanProceed, setShowModalConcentimentCanProceed] = useState<boolean>(false);
    const [showModalConcentimentCantProceed, setShowModalConcentimentCantProceed] = useState<boolean>(false);

    function onCloseModal() {
        setShowModalConcentimentCanProceed(false);
        setShowModalConcentimentCantProceed(false);
    };

    const onCloseModalX = useCallback(() => {
        setShowModalConcentimentCanProceed(false);
        setShowModalConcentimentCantProceed(false);
    }, []);

    async function handleResendTerm(tipoEnvio: string) {
        const nextDeliveryChannel = isEmailOnlyBenefit ? 'email' : tipoEnvio;

        setResendTerm(true);
        setResendTermVia(nextDeliveryChannel);
        await reSendTerm(nextDeliveryChannel);
    }

    const TermSentVia = useMemo(() => {
        if (resendTermVia && resendTermVia === 'sms') {
            return beneficiaryInfo?.celular;
        } else if (resendTermVia && resendTermVia === 'email') {
            return beneficiaryInfo?.email;
        }

        if (beneficiaryInfo?.tipoEnvio === 'sms') {
            return beneficiaryInfo?.celular;
        } else if (beneficiaryInfo?.tipoEnvio === 'email') {
            return beneficiaryInfo?.email;
        }
    }, [resendTermVia, beneficiaryInfo]);

    async function handleContinue() {
        const beneficiaryPreCadastro = await getBeneficiaryPreCad();
        
        if (!beneficiaryPreCadastro) 
            return;

        const beneficiarioJaRespondeuTermo = beneficiaryPreCadastro ? beneficiaryPreCadastro.isAceite : false;

        ProceedToForm(beneficiarioJaRespondeuTermo);
        
        if (!canProceedWithoutAccept) {
            setShowModalConcentimentCantProceed(true);
        } else {
            setShowModalConcentimentCanProceed(true);
        }
    }

    function editContact() {
        backToContact();
    }

    return (
        <Container>
            <img src={celular} alt="image-celular" />
            <SentMessageTo>{resendTerm ? 'Reenviamos' : 'Enviamos'} o <span>termo de aceite</span> do programa para o {activeDeliveryChannel === 'sms' ? ' seu número:' : ' e-mail:'}</SentMessageTo>
            <TermSentViaText>{TermSentVia}</TermSentViaText>
            <Button onClick={() => handleContinue()}>Continuar</Button>
            <BeneficiaryNotReceivedText>Beneficiário não recebeu o <span>termo de aceite</span>? {resendTerm && <span className="resend" onClick={editContact}>Editar dados de contato</span>} </BeneficiaryNotReceivedText>
            <ResendContainer>
                {!resendTerm && (
                    <>
                        <p onClick={() => handleResendTerm('email')}>Reenviar o termo via <span>E-mail</span></p>
                        {!isEmailOnlyBenefit && <p onClick={() => handleResendTerm('sms')}>Reenviar o termo via <span>SMS</span></p>}
                    </>
                )}
            </ResendContainer>
            <ModalValidTerm
                show={showModalConcentimentCanProceed}
                content={`É necessário obter o consentimento do paciente o quanto antes para que o mesmo acesse todos os benefícios do programa ${benefitName} por tempo indeterminado.`}
                confirmButtonText="Continuar"
                onClose={onCloseModal}
                onCloseX={onCloseModalX}
                confirmMethod={GoToForm}
            />
            <ModalValidTerm
                show={showModalConcentimentCantProceed}
                content={`É necessário obter o consentimento do paciente para que o cadastro no programa ${benefitName} possa ser concluído.`}
                onClose={onCloseModal}
                onCloseX={onCloseModalX}
            />
            <ModalValidTerm
                show={termDeclined}
                content={`O paciente declinou de participar do programa, caso o mesmo ainda tenha interesse favor reiniciar o cadastro.`}
                onClose={closeModalDeclinedTerm}
                onCloseX={closeModalDeclinedTerm}
            />
        </Container>
    );
}
